const ContentCard = ({
    contentType = { product, interactive },
    flags = { updated, demo, beta }
} = {}) => {
    return {
        isImageLoading: true,

        get isProduct(){
            return this.content?.type?.name === contentType.product;
        },

        get isFreeDemo(){
            const isInteractive = this.content?.type?.name === contentType.interactive;
            const isDemo = this.content?.flags?.some((flag) => flag.id == flags.demo);

            return isInteractive && isDemo && !this.userHasPremium;
        },

        get isNew(){
            return this.content?.flags?.some((flag) => flag.id == flags.new);
        },

        get isUpdated(){
            return this.content?.flags?.some((flag) => flag.id == flags.updated);
        },

        get isBeta(){
            return this.content?.flags?.some((flag) => flag.id == flags.beta);
        },

        get isDraft(){
            return !this.content?.published_at;
        },

        init() {
            this.updateRowsCount();

            this.$nextTick(() => {
                this.$refs.thumbnail.srcset = this.$refs.thumbnail.dataset.src;
            });
        },

        updateRowsCount() {
            this.$nextTick(() => {
                if (this.columns != 1) {
                    this.$refs.body?.classList.remove('sm:line-clamp-2');
                    this.$refs.body?.classList.remove('sm:line-clamp-3');
                    this.$refs.body?.classList.remove('sm:line-clamp-4');
                    return;
                }

                this.updateBodyRows();
            });
        },

        updateBodyRows(){
            const subtitle = this.$el.querySelector(`[x-ref="subtitle"]`);

            const isSubtitleEmpty = subtitle.textContent === '';

            this.$refs.body?.classList.remove('sm:line-clamp-2');
            this.$refs.body?.classList.remove('sm:line-clamp-3');
            this.$refs.body?.classList.remove('sm:line-clamp-4');

            const hasTitleTwoLines = this.hasTitleLines(2);

            if(this.hasTitleLines(1) && isSubtitleEmpty && !hasTitleTwoLines){
                this.$refs.body?.classList.add('sm:line-clamp-4');
                return;
            }

            if(hasTitleTwoLines && !isSubtitleEmpty){
                this.$refs.body?.classList.add('sm:line-clamp-2');

                return;
            }

            this.$refs.body?.classList.add('sm:line-clamp-3');
        },

        hasTitleLines(lines = 1){
            const title = this.$el.querySelector(`[x-ref="title"]`);

            const computedStyles = window.getComputedStyle(title);
            const fontSize = parseInt(computedStyles.getPropertyValue('font-size'));

            return title.scrollHeight > lines * fontSize;
        },

        syncLists({ content, selectedLists } = {}){
            this.content.selectedLists = this.availableLists.filter((availableLists) => selectedLists.indexOf(availableLists.id) >= 0)
        },
    }
}

export default ContentCard;
